import { render } from "./ProductSilo.vue?vue&type=template&id=644c23dc&scoped=true"
import script from "./ProductSilo.vue?vue&type=script&lang=js"
export * from "./ProductSilo.vue?vue&type=script&lang=js"

import "./ProductSilo.vue?vue&type=style&index=0&id=644c23dc&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\ilustranext\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-644c23dc"]])

export default __exports__